import { webPaths } from "@zplanem/web-paths"
import type React from "react"
import { Navigate } from "react-router-dom"
import { useAuth } from "../auth-context"
import { getTranslations } from "../i18n"
import { useLocale } from "../locale-context"
import { LoadingScreen } from "./loading-screen"

export const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({
	children,
}) => {
	const { user, loading } = useAuth()
	const { locale } = useLocale()
	const t = getTranslations(locale)

	if (loading) {
		return <LoadingScreen label={t.common.loading} />
	}

	if (!user) {
		return <Navigate to={webPaths.auth()} replace />
	}

	return <>{children}</>
}
